<template>
    <div class="tab_content">
        <div class="search_box clearfix">

            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.brand_id" clearable placeholder="品牌" @visible-change="getBrandList">
                <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.breed_id" clearable placeholder="品名" @visible-change="getBreedList">
                <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.grade_id" clearable placeholder="等级" @visible-change="getGradeList">
                <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->

            <el-input class="search_input search_inputBox" v-model="params.search.sales_thickness" clearable placeholder="厚度"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.search.sales_length" clearable placeholder="长度"></el-input>

            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.warehouse_id" clearable placeholder="仓库" @visible-change="getWarehouseListList">
                <el-option v-for="list in warehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>

            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="search">查询</el-button>
            <div class="execlInsert">
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">件数:{{ statistics.count }}</div>
            <div class="totalNumber">方数：{{ statistics.sales_cube }}</div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
    }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                params : {
                    page : 1,
                    per_page : 50,
                    search : {
                        breed_id : "",
                        brand_id : "",
                        grade_id : "",
                        sales_thickness : "",
                        sales_length : "",
                        warehouse_id : ""
                    }
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count  : "",
                    sales_cube  : "",
                },

                brandList : [],
                breedList : [],
                gradeList : [],
                warehouseList : [],
                // supplierList : [],


                list:[],
                tableCol:[
                    {colName:"厚度(cm)",colKey:"sales_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度(m)",colKey:"sales_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"总宽度(cm)",colKey:"sales_width_total",colWidth:111,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"片数",colKey:"",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"方数",colKey:"sales_cube",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
            }
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.inventory.spec","规格汇总表",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.$axios.post("/erp/report.inventory.spec",this.params).then((response) => {
                    if(response.data.code == 0){
                        this.list = response.data.data.list;
                        this.total = response.data.data.total;
                        this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.last_page;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                    }
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            search(){
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params.search = {
                    breed_id : "",
                    brand_id : "",
                    grade_id : "",
                    sales_thickness : "",
                    sales_length : "",
                    warehouse_id : "",
                    container_no : ""
                }
                this.getList()
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },
            // 仓库
            getWarehouseListList(visible){
                if(visible){
                    this.$getWarehouseList().then(res=>{
                        this.warehouseList = res.data.data;
                    })
                }
            },
            // 供应商
            getSupplierList(visible){
                if(visible){
                    this.$getSupplierList().then(res=>{
                        this.supplierList = res.data.data;
                    })
                }
            },

        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
